import TYPES from './_types';
import defaultState from './_state';

export default {
  [TYPES.FETCH_ERROR] (state, error = defaultState.fetchError) {
    state.fetchError = {
      ...error
    };
  },
};



// WEBPACK FOOTER //
// ./src/stores/global/_mutations.js